// export const BASE_URL = "http://localhost:6010";
export const BASE_URL = "https://crud-application-backend-sz74.onrender.com";
